import { Injectable } from '@angular/core';
import { AuthGuard, AuthService } from '@principle-theorem/ng-auth';
import { snapshot } from '@principle-theorem/shared';
import { map } from 'rxjs/operators';
import { PartnerService } from '../services/partner.service';

@Injectable({
  providedIn: 'root',
})
export class IsPartnerWorkspaceGuard extends AuthGuard {
  constructor(
    private _partner: PartnerService,
    auth: AuthService
  ) {
    super(auth);
  }

  async canActivate(): Promise<boolean> {
    return snapshot(
      this._partner.partner$.pipe(
        map((partner) => {
          return partner ? true : false;
        })
      )
    );
  }
}
